import React from "react";

/**
 * Data refresh: the existing view stays (slightly dimmed) and a thin progress bar
 * runs across the top of the block. No jumping spinner and no blank screen.
 * (For the first load, when there is no data yet, Skeleton components are used.)
 */
export default function LoadingOverlay({ loading, children }) {
  return (
    <div className="relative w-full min-w-0" aria-busy={loading || undefined}>
      {loading && (
        <div className="pointer-events-none absolute inset-x-0 top-0 h-0.5 overflow-hidden" aria-hidden="true">
          <div className="h-full w-1/3 animate-progress rounded-full bg-primary dark:bg-primary-light" />
        </div>
      )}
      <div className={`transition-opacity duration-150 ${loading ? "opacity-60" : "opacity-100"}`}>{children}</div>
    </div>
  );
}
